class NSSHeroCarousel extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Hero Carousel] Connected.");

    this.initCarousel();
    this.initPagination();

    // Cause first transition to play upon load
    const activeDotEl = this.querySelector(`.swiper-pagination-bullet-active`);
    activeDotEl?.classList.remove(`swiper-pagination-bullet-active`);

    // All controls are handled by delegation: slides (and loop-mode clones) can
    // each carry an in-flow controls block, so Swiper's own navigation binding
    // (first match only) can't cover them.
    this.addEventListener(`click`, (e) => {
      if (e.target.hasAttribute(`nss-hero-carousel-dot-index`)) {
        const index = parseInt(e.target.getAttribute(`nss-hero-carousel-dot-index`));
        if (this.debug) console.log(`[NSS][Hero Carousel] clicked index:`, index);
        this.swiper.slideToLoop(index);
        return;
      }
      if (e.target.closest(`.nss-hero-carousel-prev`)) this.swiper.slidePrev();
      else if (e.target.closest(`.nss-hero-carousel-next`)) this.swiper.slideNext();
    });

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ];
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  updatePagination(index) {
    const dotEls = this.querySelectorAll(`[nss-hero-carousel-dot-index]`);
    dotEls.forEach((dotEl) => dotEl.classList.remove(`nss-active`));
    const activeEls = this.querySelectorAll(`[nss-hero-carousel-dot-index="${index}"]`);
    activeEls.forEach((activeEl) => activeEl.classList.add(`nss-active`));
  }

  initPagination() {
    const paginationEls = this.querySelectorAll(`[nss-hero-carousel-pagination]`);
    const slidesCount = paginationEls.length;
    if (this.debug) console.log(`[NSS][Hero Carousel] slidesCount:`, slidesCount);
    paginationEls.forEach((paginationEl) => {
      for (let i = 0; i < slidesCount; i++) {
        const dotEl = document.createElement(`span`);
        dotEl.classList.add(`nss-hero-carousel-slide__dot`);
        if (i === 0) {
          dotEl.classList.add(`nss-active`);
        }
        dotEl.setAttribute(`nss-hero-carousel-dot-index`, i);
        dotEl.setAttribute(`tabindex`, 0);
        dotEl.setAttribute(`role`, `button`);
        dotEl.setAttribute(`aria-label`, `Go to slide ${i + 1}`);
        paginationEl.appendChild(dotEl);
      }
    });
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);
    const settingsEl = document.querySelector(
      `script[data-section-id="${this.dataset.sectionId}"]`
    );
    if (this.debug)
      console.log(`[NSS][Hero Carousel] settingsEl.textContent:`, settingsEl.textContent);
    const settings = JSON.parse(settingsEl.textContent);
    if (this.debug) console.log(`[NSS][Hero Carousel] settings:`, settings);

    this.swiper = new Swiper(
      carouselEl,
      Object.assign({}, settings, {
        grabCursor: true,
        slidesPerView: 1,

        a11y: {
          enabled: true,
        },

        // Navigation intentionally omitted — arrow clicks are delegated in
        // connectedCallback so every slide's in-flow controls (and their loop
        // clones) work, not just the first match in the DOM.
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },

        on: {
          realIndexChange: () => {
            if (this.debug)
              console.log(`[NSS][Hero Carousel] this.swiper.realIndex:`, this.swiper.realIndex);
            this.updatePagination(this.swiper.realIndex);
          },
        },
      })
    );
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Hero Carousel] Handle editor event, e:", e);

    switch (e.type) {
      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`nss-hero-carousel-slide`);
        const index = slideEl.getAttribute(`data-swiper-slide-index`);
        if (this.debug) console.log("[NSS][Hero Carousel] Sliding to index:", index);
        this.swiper.slideTo(index);
        break;
    }
  }
}

let elementName = `nss-hero-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSHeroCarousel);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
